import { handleActions } from '@gef-ui/utils/fsaActions';
import path from "ramda/es/path";
import assoc from "ramda/es/assoc";
import curry from "ramda/es/curry";
import { actionTypes } from '../../constants';
const updateSubheader = curry((open, state, payload)=>{
    const initiallyOpen = path([
        payload,
        'initiallyOpen'
    ])(state);
    return assoc(payload, {
        subheaderId: payload,
        initiallyOpen,
        open
    }, state);
});
const openSubheader = (state, { payload })=>updateSubheader(true, state, payload);
const closeSubheader = (state, { payload })=>updateSubheader(false, state, payload);
const registerSubheader = (state, { payload: { subheaderId, initiallyOpen } })=>{
    const alreadyOpen = path([
        subheaderId,
        'open'
    ])(state);
    return assoc(subheaderId, {
        subheaderId,
        initiallyOpen,
        open: alreadyOpen !== undefined ? alreadyOpen : initiallyOpen
    }, state);
};
const subheaderReducerMap = {
    [actionTypes.OPEN_SUBHEADER]: openSubheader,
    [actionTypes.CLOSE_SUBHEADER]: closeSubheader,
    [actionTypes.REGISTER_SUBHEADER]: registerSubheader
};
export default handleActions(subheaderReducerMap, {});
